import { getModel, getData } from '@/emap-utils'; // import { resolve } from 'url'

const DEFAULT_SETTINGS = {
  selection: true,
  pageable: true,
  customOptions: null
};

const noop = _ => _; // const isAbsPath = p => {
//   return p.startsWith('http://') || p.startsWith('https://')
// }


const resolve = (from, to) => {
  const resolvedUrl = new URL(to, new URL(from, 'http://resolved'));

  if (resolvedUrl.hostname === 'resolved') {
    // `from` is a relative URL.
    const {
      pathname,
      search,
      hash
    } = resolvedUrl;
    return pathname + search + hash;
  }

  return resolvedUrl.toString();
};

export default class EmapPlugin {
  constructor(options) {
    this.settings = Object.assign({}, DEFAULT_SETTINGS, options);
  }

  install(ctx) {
    ctx.plugin('props', (vm, props) => {
      return { ...props,
        selection: this.settings.selection,
        showPager: this.settings.pageable,
        ...(this.settings.customOptions || {})
      };
    });
    ctx.plugin('fetch-meta', async (vm, columns, cb) => {
      const {
        pagePath,
        action: actionId,
        params,
        datamodel,
        alwaysHide = []
      } = this.settings;

      if (datamodel) {
        return datamodel;
      }

      try {
        const model = await getModel({
          pagePath,
          actionId,
          type: 'grid',
          params
        });

        if (model) {
          this.dataUrl = model.url;
          const metas = model.controls.filter(item => !item.hidden && !item['grid.hidden'] && !alwaysHide.includes(item.prop)).map(item => {
            const newItem = { ...item,
              label: item.caption,
              prop: item.name,
              fixed: !!item['grid.fixed'] || item.fixed,
              width: item['grid.width'] || item.width
            };
            let jsonParam = item['form.JSONParam'];

            if (jsonParam) {
              try {
                jsonParam = JSON.parse(jsonParam);

                if (jsonParam.sortable) {
                  newItem.sortable = 'custom';
                }
              } catch (e) {
                console.warn('emap parse error, invalid JSONParam', jsonParam);
              }
            }

            return newItem;
          });
          cb(metas);
        } else {
          cb(null);
        }
      } catch (e) {
        console.error(e);
        cb(null);
      }
    });
    ctx.plugin('fetch-data', async (vm, data, query, cb) => {
      const {
        dataUrl
      } = this;

      if (!dataUrl) {
        cb(null);
        return;
      }

      const {
        pagePath,
        action: actionId,
        beforeSend = noop
      } = this.settings; // console.log(pagePath, dataUrl, resolve(pagePath, dataUrl));
      // const queryUrl = isAbsPath(dataUrl) ? dataUrl : resolve(pagePath, dataUrl)

      const queryUrl = resolve(pagePath, dataUrl);

      try {
        data = await getData(queryUrl, actionId, Object.assign({
          pageNumber: vm.pager.currentPage ? vm.pager.currentPage : 1,
          pageSize: vm.pager.pageSize ? vm.pager.pageSize : 10
        }, query), beforeSend.bind(vm), vm);
        cb(data);
      } catch (e) {
        console.error(e);
        cb(null);
      }
    });
    ctx.plugin('format-data', (vm, data = {}) => {
      const {
        rows
      } = data || {};
      return rows || [];
    });
    ctx.plugin('format-page', (vm, pager, data) => {
      const {
        totalSize,
        pageNumber,
        pageSize
      } = data || {};

      if (pager && Object.keys(pager).length > 0 && pageNumber && pageSize && totalSize) {
        return {
          total: totalSize,
          currentPage: pageNumber,
          pageSize
        };
      } else {
        return pager;
      }
    });
  }

}